export const BETA_AUTH_URL =
  "federate-tpsstaffaugmentationservice-beta.auth.us-west-2.amazoncognito.com";
export const BETA_GRAPHQL_ENDPOINT =
  "https://om7zsj2ginertjbzb36wp2q6iq.appsync-api.us-west-2.amazonaws.com/graphql";
export const GAMMA_GRAPHQL_ENDPOINT =
  "https://om7zsj2ginertjbzb36wp2q6iq.appsync-api.us-west-2.amazonaws.com/graphql";
export const PROD_GRAPHQL_ENDPOINT =
  "https://om7zsj2ginertjbzb36wp2q6iq.appsync-api.us-west-2.amazonaws.com/graphql";
